export const PREDEFINED_QUESTION_IDS: string[] = [
    'intl-msg:chatbot.predefinedQuestion.whatIsMdm',
    'intl-msg:chatbot.predefinedQuestion.fetchLogs',
    'intl-msg:chatbot.predefinedQuestion.createCampaign',
];
